import { render, staticRenderFns } from "./addOrder.vue?vue&type=template&id=2a0521aa&"
import script from "./addOrder.vue?vue&type=script&lang=js&"
export * from "./addOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports